import React, { useState, useEffect } from "react";
import Loader from "../../../loader/Loader";
import { toast } from "react-toastify";
import axios from "axios";
import { domain } from "../../../../security";
import { useSelector } from "react-redux";
import { selectUserID } from "../../../../redux/IchthusSlice";

const AddBrands = ({ onClose, refreshData, BrandToEdit }) => {
  const currentUserID = useSelector(selectUserID);

  const [formData, setFormData] = useState({
    brandName: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (BrandToEdit) {
      setFormData({
        brandName: BrandToEdit.brandName || BrandToEdit.BrandName || "",
      });
    } else {
      setFormData({ brandName: "" });
    }
  }, [BrandToEdit]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const apiUrl = `${domain}/api/Brands`;

    const payload = {
      BrandName: formData.brandName,
      UserID: currentUserID,
    };

    try {
      if (BrandToEdit) {
        const id = BrandToEdit.id || BrandToEdit.Id;
        await axios.put(`${apiUrl}/${id}`, payload);
        toast.success("Brand updated successfully");
      } else {
        await axios.post(apiUrl, payload);
        toast.success("Brand added successfully");
      }
      refreshData();
      onClose();
    } catch (error) {
      console.error("Validation Error Details:", error.response?.data?.errors);
      const serverMessage =
        error.response?.data?.title || "Check required fields";
      toast.error(`Error: ${serverMessage}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-6">
      {isLoading && <Loader />}
      <div className="relative w-full">
        <button
          onClick={onClose}
          className="absolute -top-2 -right-2 p-2 text-gray-500 hover:text-gray-700"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <h2 className="text-2xl mb-6 font-bold text-gray-800">
          {BrandToEdit ? "Edit Brand" : "Add Brand"}
        </h2>

        <form onSubmit={handleFormSubmit} className="space-y-5">
          <div>
            <label
              htmlFor="brandName"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Brand Name
            </label>
            <input
              id="brandName"
              type="text"
              required
              placeholder="Nike, Apple, Samsung, etc."
              className="border border-gray-300 rounded-md py-2 px-3 w-full focus:ring-indigo-500 focus:border-indigo-500 outline-none"
              value={formData.brandName}
              onChange={handleInputChange}
            />
          </div>

          <button
            type="submit"
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 rounded-lg shadow transition-colors"
          >
            {BrandToEdit ? "Update Brand" : "Add Brand"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddBrands;
